import { createSlice } from '@reduxjs/toolkit';
import { returnUpdatedConnector } from '../../Utils/charging-point';

const initialChargerState = {
  error: false,
  connectorData: null,
  isButtonLoading: false
};

const chargingPointSlice = createSlice({
  name: 'chargingPoint',
  initialState: initialChargerState,
  reducers: {
    setConnector: (state, action) => {
      const { connector, error } = action.payload;
      if (connector) {
        state.connectorData = connector;
      }
      if (error) {
        state.error = action.payload.error;
      }
    },
    updateOCPPChargingPoint: (state, action) => {
      let parsedData;
      const { data } = action.payload;

      if (typeof data === 'string') {
        try {
          parsedData = JSON.parse(data);
        } catch (error) {
          console.error("Error processing WebSocket data:", error);
          return;
        }
      } else if (typeof data === 'object') {
        parsedData = data;
      } else {
        console.error("Received data is not a valid JSON string or object:", data);
        return;
      }

      if (parsedData) {
        const connector = { ...state.connectorData };

        if (connector?.chargingPoint.slug === parsedData.slug) {
          state.connectorData = returnUpdatedConnector(connector, parsedData);
          state.isButtonLoading = false;
        }
      }
    },
    setIsButtonLoading: (state, action) => {
      const { isLoading } = action.payload;
      state.isButtonLoading = isLoading;
    }
  }
});

export const { setConnector, updateOCPPChargingPoint, setIsButtonLoading } =
  chargingPointSlice.actions;

export default chargingPointSlice.reducer;
